"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMixRatios = exports.DefinitionFields = exports.FormulationDate = exports.Supplier = exports.Style = exports.MixRatio = void 0;
const effect_1 = require("effect");
const Nutrition = __importStar(require("../../../../../../nutrition"));
const Definition = __importStar(require("../common"));
const MixRatio = __importStar(require("./mix-ratio"));
const Style = __importStar(require("./style"));
exports.MixRatio = __importStar(require("./mix-ratio"));
exports.Style = __importStar(require("./style"));
const NAMESPACE = 'Culligan.Device.Capability.Consumable.Definition.Enhancement';
exports.Supplier = effect_1.Schema.Literal('Sensient Flavors LLC', 'Essential Flavors & Fragrances, Inc.').annotations({
    identifier: `${NAMESPACE}.Supplier`,
    description: 'The entity that supplies and/or formulates this product',
});
exports.FormulationDate = effect_1.Schema.DateTimeUtc.annotations({
    identifier: `${NAMESPACE}.FormulationDate`,
    description: 'The formulation date specified on the datasheet',
});
exports.DefinitionFields = {
    ...Definition.Fields,
    flavor: effect_1.Schema.NonEmptyString.annotations({
        identifier: `${NAMESPACE}.DefinitionFields.flavor`,
    }),
    description: effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString).annotations({
        identifier: `${NAMESPACE}.DefinitionFields.description`,
    }),
    ingredients: effect_1.Schema.Array(effect_1.Schema.NonEmptyString).annotations({
        identifier: `${NAMESPACE}.DefinitionFields.ingredients`,
    }),
    tags: effect_1.Schema.Array(effect_1.Schema.NonEmptyString).annotations({
        identifier: `${NAMESPACE}.DefinitionFields.tags`,
    }),
    flavored: effect_1.Schema.Boolean.annotations({
        identifier: `${NAMESPACE}.DefinitionFields.flavored`,
        description: 'Whether this enhancement is supposed to flavor the drink it is added to',
    }),
    nominalMixRatio: MixRatio.NominalMixRatio,
    mixRatioScalars: MixRatio.MixRatioScalarsFromUnsorted,
    nutritionalInfo: Nutrition.NutritionalInfo.annotations({
        identifier: `${NAMESPACE}.DefinitionFields.nutritionalInfo`,
        description: 'The nutritional info corresponding to 100 grams of the enhancement in undiluted state',
    }),
    supplier: effect_1.Schema.optionalWith(exports.Supplier, { exact: true }),
    formulationDate: effect_1.Schema.optionalWith(exports.FormulationDate, { exact: true }),
    style: Style.Style,
};
/**
 *
 * @param nominalMixRatio See {@link MixRatio.NominalMixRatio}
 * @param mixRatioScalar See {@link MixRatio.MixRatioScalar}
 * @returns The mix ratio
 */
const getMixRatio = (nominalMixRatio, mixRatioScalar) => nominalMixRatio / mixRatioScalar;
const getMixRatios = (nominalMixRatio, mixRatioScalars) => mixRatioScalars.map(scalar => getMixRatio(nominalMixRatio, scalar));
exports.getMixRatios = getMixRatios;
//# sourceMappingURL=index.js.map